/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | ups_standard | Standard℠|
 * | ups_ground | Ground|
 * | ups_saver | Saver®|
 * | ups_3_day_select | 3 Day Select®|
 * | ups_second_day_air | 2nd Day Air®|
 * | ups_second_day_air_am | 2nd Day Air® A.M.|
 * | ups_next_day_air | Next Day Air®|
 * | ups_next_day_air_saver | Next Day Air Saver®|
 * | ups_next_day_air_early_am | Next Day Air® Early|
 * | ups_mail_innovations_bpm_flat | Mail Innovations BPM Flat |
 * | ups_mail_innovations_bpm_parcel | Mail Innovations BPM Parcel |
 * | ups_mail_innovations_irregular | Mail Innovations Irregular |
 * | ups_mail_innovations_media_mail | Mail Innovations Media Mail |
 * | ups_mail_innovations_parcel | Mail Innovations Parcel |
 * | ups_mail_innovations_standard_flat | Mail Innovations Standard Flat |
 * | ups_surepost | Surepost|
 * | ups_surepost_bound_printed_matter | SurePost® Bound Printed Matter|
 * | ups_surepost_lightweight | Surepost Lightweight|
 * | ups_surepost_media | SurePost® Media|
 * | ups_express | Express®|
 * | ups_express_1200 | Express 12:00|
 * | ups_express_plus | Express Plus®|
 * | ups_expedited | Expedited®|
 * | ups_express_early | Express® Early|
 * | ups_access_point_economy | Access Point™ Economy|
 */
export const ServiceLevelUPSEnum = {
  UpsStandard: "ups_standard",
  UpsGround: "ups_ground",
  UpsSaver: "ups_saver",
  Ups3DaySelect: "ups_3_day_select",
  UpsSecondDayAir: "ups_second_day_air",
  UpsSecondDayAirAm: "ups_second_day_air_am",
  UpsNextDayAir: "ups_next_day_air",
  UpsNextDayAirSaver: "ups_next_day_air_saver",
  UpsNextDayAirEarlyAm: "ups_next_day_air_early_am",
  UpsMailInnovationsBpmFlat: "ups_mail_innovations_bpm_flat",
  UpsMailInnovationsBpmParcel: "ups_mail_innovations_bpm_parcel",
  UpsMailInnovationsIrregular: "ups_mail_innovations_irregular",
  UpsMailInnovationsMediaMail: "ups_mail_innovations_media_mail",
  UpsMailInnovationsParcel: "ups_mail_innovations_parcel",
  UpsMailInnovationsStandardFlat: "ups_mail_innovations_standard_flat",
  UpsSurepost: "ups_surepost",
  UpsSurepostBoundPrintedMatter: "ups_surepost_bound_printed_matter",
  UpsSurepostLightweight: "ups_surepost_lightweight",
  UpsSurepostMedia: "ups_surepost_media",
  UpsExpress: "ups_express",
  UpsExpress1200: "ups_express_1200",
  UpsExpressPlus: "ups_express_plus",
  UpsExpedited: "ups_expedited",
  UpsExpressEarly: "ups_express_early",
  UpsAccessPointEconomy: "ups_access_point_economy",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | ups_standard | Standard℠|
 * | ups_ground | Ground|
 * | ups_saver | Saver®|
 * | ups_3_day_select | 3 Day Select®|
 * | ups_second_day_air | 2nd Day Air®|
 * | ups_second_day_air_am | 2nd Day Air® A.M.|
 * | ups_next_day_air | Next Day Air®|
 * | ups_next_day_air_saver | Next Day Air Saver®|
 * | ups_next_day_air_early_am | Next Day Air® Early|
 * | ups_mail_innovations_bpm_flat | Mail Innovations BPM Flat |
 * | ups_mail_innovations_bpm_parcel | Mail Innovations BPM Parcel |
 * | ups_mail_innovations_irregular | Mail Innovations Irregular |
 * | ups_mail_innovations_media_mail | Mail Innovations Media Mail |
 * | ups_mail_innovations_parcel | Mail Innovations Parcel |
 * | ups_mail_innovations_standard_flat | Mail Innovations Standard Flat |
 * | ups_surepost | Surepost|
 * | ups_surepost_bound_printed_matter | SurePost® Bound Printed Matter|
 * | ups_surepost_lightweight | Surepost Lightweight|
 * | ups_surepost_media | SurePost® Media|
 * | ups_express | Express®|
 * | ups_express_1200 | Express 12:00|
 * | ups_express_plus | Express Plus®|
 * | ups_expedited | Expedited®|
 * | ups_express_early | Express® Early|
 * | ups_access_point_economy | Access Point™ Economy|
 */
export type ServiceLevelUPSEnum = ClosedEnum<typeof ServiceLevelUPSEnum>;

/** @internal */
export const ServiceLevelUPSEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelUPSEnum
> = z.nativeEnum(ServiceLevelUPSEnum);

/** @internal */
export const ServiceLevelUPSEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelUPSEnum
> = ServiceLevelUPSEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelUPSEnum$ {
  /** @deprecated use `ServiceLevelUPSEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelUPSEnum$inboundSchema;
  /** @deprecated use `ServiceLevelUPSEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelUPSEnum$outboundSchema;
}
